<template>
  <v-app id="inspire">
    <v-main>
      <v-overlay :value="loading"></v-overlay>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Changement de mot de passe</v-toolbar-title>
                <v-spacer></v-spacer>
                
              </v-toolbar>
              <v-card-text>
                <v-form
                 ref="formUpdatePwd"
                 v-model="valid"
                 :lazy-validation="lazy"
                 >
                  <v-text-field
                  id="pwdOld"
                    label="Ancien mot de passe"
                    name="pwdOld"
                    prepend-icon="mdi-account"
                    type="password" v-model="pwdOld"
                    required
                    :rules="pwdOldRules"
                  ></v-text-field>

                  <v-text-field
                    id="pwdNew"
                    label="Nouveau mot de passe"
                    name="pwdNew"
                    prepend-icon="mdi-lock" require
                    type="password" v-model="pwdNew" 
                    required :rules="pwdNewRules"
                  ></v-text-field>

                  <v-text-field
                    id="pwdConf"
                    label="Confirmation du mot de passe"
                    name="pwdConf"
                    prepend-icon="mdi-lock" require
                    type="password" v-model="pwdConf" 
                    required :rules="pwdConfRules"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="updatePwd" :loading="loading" color="primary" :disabled="!valid">Valider</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
    </v-main>
  </v-app>
</template>

<script>
  import {UserService} from '../providers/UserService.js';
const userService = new UserService();
export default {
  
    name: 'Connexion',
  data() {
    return {
      loading:false,
      pwdOld: "",
      pwdOldRules: [
      v => !!v || 'Ancien mot de passe oblogatoire',
      ],
      pwdNew: "",
      pwdNewRules: [
      v => !!v || 'Nouveau mot de passe oblogatoire',
      ],
      pwdConf:"",
      pwdConfRules: [
      v => !!v || 'Confirmation du mot de passe oblogatoire',
      ],
      valid: true,
      
    };
  },
  methods: {

      
      updatePwd: function(){
        this.loading = true;
        userService.updatePassword(this.pwdOld, this.pwdNew,this.pwdConf,this.$root.user.idUser).then(res => { 
          this.loading = false;
          if(res){
            if (res.err !='error') {
              this.pwdOld = "";
              this.pwdNew =  "";
              this.pwdConf = "";
              this.$dialog.notify.success(res.err_msg, {
                position: 'bottom-right',
                timeout: 5000
              })
                         
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
          
      }
  }
};
  
</script>
